import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { m } from 'motion-v'
import { wobble, wobbleHor } from '~/composables/brandMotion'


export default /*@__PURE__*/_defineComponent({
  __name: 'MMotionWobble',
  props: {
    loud: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(m).span, {
    "while-hover": __props.loud ? _unref(wobbleHor) : _unref(wobble),
    style: { display: 'inline-block' }
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["while-hover"]))
}
}

})